<template>
  <v-footer
    fixed
    app
    inset
    :height="theme.footer_height"
    :color="theme.footer_bg_color"
  >
    <v-btn
      block
      large
      class="btn"
      :dark="!btn.disabled"
      :color="theme.btn_color_primary"
      :disabled="btn.disabled"
      @click="payment"
    >
      <v-layout row>
        <v-flex
          xs12
          class="text-xs-center nowrap-text"
        >
          {{ btn.text }}
        </v-flex>
      </v-layout>
    </v-btn>
    <template>
      <form
        v-for="(p, index) in paymentModes"
        :key="index"
        :id="'payment-form-' + p.code"
        :action="(env !== 'production' || parseInt(gid) === 21) ? paymentTypes[p.code].dev : paymentTypes[p.code].prod"
        method="post"
      >
        <input
          type="hidden"
          name="member_id"
          :value="memberId"
        />
        <input
          type="hidden"
          name="loyalty_group_id"
          :value="loyaltyGroupId"
        />
        <input
          type="hidden"
          name="platform_id"
          value=5
        />
        <input
          type="hidden"
          name="platform_transaction_id"
          :value="activeBill.preview_bill_id"
        />
        <input
          type="hidden"
          name="is_guest"
          :value="isGuest"
        />
        <input
          type="hidden"
          name="reference_id"
          :value="activeBill.preview_bill_id"
        />
        <input
          type="hidden"
          name="transaction_amount"
          :value="activeBill.total"
        />
        <input
          type="hidden"
          name="restaurant_id"
          :value="rid"
        />
        <input
          type="hidden"
          name="account"
          :value="epayAccount"
        />
        <input
          type="hidden"
          name="payment_mode"
          :value="paymentTypes[p.code].mode"
        />
        <input
          type="hidden"
          name="payment_time"
          value="payAfterServe"
        />
        <input
          type="hidden"
          name="redirect_url"
          :value="returnUrl"
        />
        <input
          type="hidden"
          name="hash"
          :value="hash"
        />
      </form>
    </template>
  </v-footer>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    hash: null
  }),
  computed: {
    ...mapGetters('config', [
      'theme', 'redirectUrl', 'paymentTypes', 'paymentModes', 'restaurant',
      'guestId', 'epayAccount', 'gid', 'rid', 'mode', 'restaurants',
      'posType', 'loyaltyGroupId'
    ]),
    ...mapGetters('member', [
      'points', 'profile', 'isMember'
    ]),
    ...mapGetters('auth', [
      'user'
    ]),
    ...mapGetters('order', [
      'paymentMode', 'activeBill'
    ]),
    env () {
      return process.env.NODE_ENV
    },
    btn () {
      if (this.paymentMode) {
        const text = this.isMember ? this.$t('member_checkout') : this.$t('guest_checkout') // this.$t('pay_by') + this.$t(this.paymentTypes[this.paymentMode.code].title)
        return {
          disabled: false,
          text: text
        }
      }
      return {
        disabled: true,
        text: this.$t('select_payment_mode')
      }
    },
    isGuest () {
      return (this.isMember) ? 0 : 1
    },
    memberId () {
      if (this.isMember) {
        return this.profile.loyalty_member_id
      }
      return 0 // this.guestId
    },
    returnUrl () {
      return this.redirectUrl.payAfterServe
    }
  },
  methods: {
    async logPaymentData () {
      try {
        let content = { 
          ...this.activeBill,
          loyalty_group_id: document.getElementsByName('loyalty_group_id')[0].value,
          platform_id: document.getElementsByName('platform_id')[0].value,
          platform_transaction_id: document.getElementsByName('platform_transaction_id')[0].value,
          is_guest: document.getElementsByName('is_guest')[0].value,
          reference_id: document.getElementsByName('reference_id')[0].value,
          transaction_amount: document.getElementsByName('transaction_amount')[0].value,
          restaurant_id: document.getElementsByName('restaurant_id')[0].value,
          account: document.getElementsByName('account')[0].value,
          payment_mode: document.getElementsByName('payment_mode')[0].value,
          payment_time: document.getElementsByName('payment_time')[0].value,
          redirect_url: document.getElementsByName('redirect_url')[0].value,
          hash: document.getElementsByName('hash')[0].value
        }
        if (this.isMember) {
          content.member = this.profile
        }
        await axios.post('/api/log', {
          action: 'directToEPay',
          content: content
        })
      } catch (e) { }
    },
    async payment () {
      if (this.rInfoExpiredAlert()) {
        return
      }
      this.$bus.$emit('showFullLoading', true)

      // First get current bill
      const activeBill = Object.assign({}, this.activeBill)
      await this.$store.dispatch('order/previewBill', this.activeBill.tid)

      // Changes in item, but there are still items in bill
      if (JSON.stringify(activeBill) !== JSON.stringify(this.activeBill)) {
        if (!this.activeBill || !this.activeBill.billno) {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: this.$t('bill_not_found_notice'),
            title: this.$t('bill_not_found_title'),
            modal: true,
            buttons: [{ text: 'Ok', path: 'bills' }]
          })
          this.$bus.$emit('showFullLoading', false)
          return
        } else {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: this.$t('change_in_bill_notice'),
            title: this.$t('change_in_bill_title'),
            modal: true,
            buttons: [{ text: 'Ok' }]
          })
          this.$bus.$emit('showFullLoading', false)
          return
        }
      } else {
        // Get hash from server
        const { data } = await axios.post('/api/epay/md5', {
          guest_id: 0, // this.guestId
          loyalty_group_id: this.loyaltyGroupId,
          restaurant_id: this.rid,
          transaction: this.activeBill,
          type: 'payAfterServe'
        })
        this.hash = data

        // Wait for 1 second before submitting since the form input is not set immediately
        setTimeout(async () => {
          const formHash = document.getElementsByName('hash')[0].value
          if (!formHash) {
            this.$store.dispatch('responseMessage', {
              type: 'error',
              title: 'Unable to checkout',
              text: 'Failed to check order from server. Please try again',
              modal: true
            })
            this.$bus.$emit('showFullLoading', false)
            return
          }

          await this.$store.dispatch('order/saveActiveBillEpayClientRef')
          this.$bus.$emit('showFullLoading', false)
          if (this.orderMsg) {
            this.$store.dispatch('responseMessage', {
              type: 'error',
              title: 'Unable to submit',
              text: this.orderMsg,
              modal: true
            })
            return
          }

          this.logPaymentData()
          document.getElementById('payment-form-' + this.paymentMode.code).submit()
        }, 1000)
      }
    }
  }
}
</script>

<style scoped>
.btn {
  margin: 10px;
}
.nowrap-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/PayBillFooter.vue